import LabeledTextField from '@src/components/CustomTextField/LabeledTextField';
import {
	Autocomplete,
	Box,
	Paper,
	IconButton,
	SelectChangeEvent,
	Typography,
	styled,
	Stack,
	Button,
} from '@mui/material';
import { FormikProps } from 'formik';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import { ApplicationContext } from '@src/contexts/ApplicationContext';
import React, { useEffect, useState } from 'react';
import AutoComplete from '@src/components/CustomSelect/AutoComplete';
import {
	AgeGroupOptions,
	BooleanOptions,
	BuyerTypeOptions,
	ContactTimeOptions,
	DeliveryAvailabilityOptions,
	DigitalUsageOptions,
	PartsUsagePreferenceOptions,
	PlansToBuySellOptions,
	PreferredLanguageOptions,
	PurchaseFrequencyOptions,
	PurchaseModeOptions,
	ServiceChannelOptions,
} from '@src/pages/Register/utils';

// additionalProfile": {
// 	"ageGroup": "30-40",
// 	"preferredLanguageForCommunication": "English",
// 	"plansToBuySellMachines": "Maybe",
// 	"interestedInFinanceInsuranceProducts": "Yes",
// 	"preferredServiceChannel": "On-site",
// 	"partsUsagePreference": "Both",
// 	"optInForOffersProductUpdates": true,
// 	"preferredContactTime": "Morning",
// 	"nearestLandmark": "Near City Mall",
// 	"availabilityForDeliveryService": "Weekdays",
// 	"referredBy": "XYZ DRP Partner",
// 	"npsScore": 9,
// 	"digitalUsage": "Sometimes",
// 	"interestedInAppDemoCall": true
// }

function AdditionalDetails({ additionalDetails, setAdditionalDetails }: any) {
	return (
		<Box display="flex" flexDirection="column" gap={2}>
			<AutoComplete
				selectedOption={
					AgeGroupOptions?.find((option) => option.id === additionalDetails.ageGroup) || null
				}
				options={AgeGroupOptions}
				onChange={(newValue) => {
					setAdditionalDetails({ ...additionalDetails, ageGroup: newValue?.id || '' });
				}}
				label="Age Group"

				// error={Boolean(additionalDetails.ageGroup && additionalDetails.ageGroup)}
				// errorText={getErrorText('ageGroup')}
			/>

			<AutoComplete
				selectedOption={
					PreferredLanguageOptions?.find(
						(option) => option.id === additionalDetails.preferredLanguageForCommunication
					) || null
				}
				options={PreferredLanguageOptions}
				onChange={(newValue) => {
					setAdditionalDetails({
						...additionalDetails,
						preferredLanguageForCommunication: newValue?.id || '',
					});
				}}
				label="Preferred Language"

				// error={Boolean(additionalDetails.preferredLanguage && additionalDetails.preferredLanguage)}
				// errorText={getErrorText('preferredLanguage')}
			/>

			<AutoComplete
				selectedOption={
					PlansToBuySellOptions?.find(
						(option) => option.id === additionalDetails.plansToBuySellMachines
					) || null
				}
				options={PlansToBuySellOptions}
				onChange={(newValue) => {
					setAdditionalDetails({
						...additionalDetails,
						plansToBuySellMachines: newValue?.id || '',
					});
				}}
				label="Plans to Buy/Sell Machines (12 months)"

				// error={Boolean(additionalDetails.machinePlans && additionalDetails.machinePlans)}
				// errorText={getErrorText('machinePlans')}
			/>

			<AutoComplete
				selectedOption={
					PlansToBuySellOptions?.find(
						(option) => option.id === additionalDetails.interestedInFinanceInsuranceProducts
					) || null
				}
				options={PlansToBuySellOptions}
				onChange={(newValue) => {
					setAdditionalDetails({
						...additionalDetails,
						interestedInFinanceInsuranceProducts: newValue?.id || '',
					});
				}}
				label="Interested in Finance/Insurance Products"

				// error={Boolean(additionalDetails.interestedInFinance && additionalDetails.interestedInFinance)}
				// errorText={getErrorText('interestedInFinance')}
			/>

			<AutoComplete
				selectedOption={
					ServiceChannelOptions?.find(
						(option) => option.id === additionalDetails.preferredServiceChannel
					) || null
				}
				options={ServiceChannelOptions}
				onChange={(newValue) => {
					setAdditionalDetails({
						...additionalDetails,
						preferredServiceChannel: newValue?.id || '',
					});
				}}
				label="Preferred Service Channel"

				// error={Boolean(
				// 	additionalDetails.preferredServiceChannel && additionalDetails.preferredServiceChannel
				// )}
				// errorText={getErrorText('preferredServiceChannel')}
			/>

			<AutoComplete
				selectedOption={
					PartsUsagePreferenceOptions?.find(
						(option) => option.id === additionalDetails.partsUsagePreference
					) || null
				}
				options={PartsUsagePreferenceOptions}
				onChange={(newValue) => {
					setAdditionalDetails({
						...additionalDetails,
						partsUsagePreference: newValue?.id || '',
					});
				}}
				label="Parts Usage Preference"

				// error={Boolean(additionalDetails.partsUsagePreference && additionalDetails.partsUsagePreference)}
				// errorText={getErrorText('partsUsagePreference')}
			/>

			<AutoComplete
				selectedOption={
					BooleanOptions?.find(
						(option) => option.id === additionalDetails.optInForOffersProductUpdates?.toString()
					) || null
				}
				options={BooleanOptions || []}
				onChange={(newValue) => {
					setAdditionalDetails({
						...additionalDetails,
						optInForOffersProductUpdates: newValue?.id === 'true',
					});
				}}
				label="Opt-in for Offers & Product Updates"

				// error={Boolean(additionalDetails.optInForOffers && additionalDetails.optInForOffers)}
				// errorText={getErrorText('optInForOffers')}
			/>

			<AutoComplete
				selectedOption={
					ContactTimeOptions?.find(
						(option) => option.id === additionalDetails.preferredContactTime
					) || null
				}
				options={ContactTimeOptions}
				onChange={(newValue) => {
					setAdditionalDetails({
						...additionalDetails,
						preferredContactTime: newValue?.id || '',
					});
				}}
				label="Preferred Contact Time"

				// error={Boolean(additionalDetails.preferredContactTime && additionalDetails.preferredContactTime)}
				// errorText={getErrorText('preferredContactTime')}
			/>

			<LabeledTextField
				label="Nearest Landmark"
				value={additionalDetails.nearestLandmark}
				onChange={(e) =>
					setAdditionalDetails({ ...additionalDetails, nearestLandmark: e.target.value })
				}
				// error={Boolean(additionalDetails.nearestLandmark && additionalDetails.nearestLandmark)}
				// errorText={getErrorText('nearestLandmark')}
				styles={{ width: '100%' }}
			/>

			<AutoComplete
				selectedOption={
					DeliveryAvailabilityOptions?.find(
						(option) => option.id === additionalDetails.availabilityForDeliveryService
					) || null
				}
				options={DeliveryAvailabilityOptions}
				onChange={(newValue) => {
					setAdditionalDetails({
						...additionalDetails,
						availabilityForDeliveryService: newValue?.id || '',
					});
				}}
				label="Availability for Delivery/Service"

				// error={Boolean(additionalDetails.deliveryAvailability && additionalDetails.deliveryAvailability)}
				// errorText={getErrorText('deliveryAvailability')}
			/>

			<LabeledTextField
				label="Referred By (Name/DRP/Shop)"
				value={additionalDetails.referredBy}
				onChange={(e) => setAdditionalDetails({ ...additionalDetails, referredBy: e.target.value })}
				// error={Boolean(additionalDetails.referredBy && additionalDetails.referredBy)}
				// errorText={getErrorText('referredBy')}
				styles={{ width: '100%' }}
			/>

			<LabeledTextField
				label="Would Recommend YLSpares? (0-10)"
				value={additionalDetails.npsScore}
				onChange={(e) => setAdditionalDetails({ ...additionalDetails, npsScore: e.target.value })}
				type="number"
				// error={Boolean(additionalDetails.npsScore && additionalDetails.npsScore)}
				// errorText={getErrorText('npsScore')}
				styles={{ width: '100%' }}
			/>

			<AutoComplete
				selectedOption={
					DigitalUsageOptions?.find((option) => option.id === additionalDetails.digitalUsage) ||
					null
				}
				options={DigitalUsageOptions}
				onChange={(newValue) => {
					setAdditionalDetails({ ...additionalDetails, digitalUsage: newValue?.id || '' });
				}}
				label="Use WhatsApp/Smartphone for Orders"

				// error={Boolean(additionalDetails.usesWhatsApp && additionalDetails.usesWhatsApp)}
				// errorText={getErrorText('usesWhatsApp')}
			/>

			<AutoComplete
				selectedOption={
					BooleanOptions?.find(
						(option) => option.id === additionalDetails.interestedInAppDemoCall?.toString()
					) || null
				}
				options={BooleanOptions || []}
				onChange={(newValue) => {
					setAdditionalDetails({
						...additionalDetails,
						interestedInAppDemoCall: newValue?.id === 'true',
					});
				}}
				label="Interested in App Demo Call"

				// error={Boolean(additionalDetails.interestedInAppDemo && additionalDetails.interestedInAppDemo)}
				// errorText={getErrorText('interestedInAppDemo')}
			/>
		</Box>
	);
}

export default AdditionalDetails;
